import React, { useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useResetInputs } from "src/Contexts";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { ModalCore } from "src/Pages/components";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";
import { UseFeaturesFormulario } from "./Hooks/UseFeaturesFormulario";
import { FormCommissionProducer } from "./FormularioComissaoProdutor";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";

interface IModalCommissionProducer {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalComissaoProdutor = ({
  openModal,
  setOpenModal,
}: IModalCommissionProducer) => {
  const { userPerfil } = useAuthContext();
  const { resetInputs } = useResetInputs();
  const { id } = useConfigPageContext();

  const { handleSubmit, loading: loadingSubmit } = UseFeaturesFormulario({
    setOpenModal,
  });

  useEffect(() => {
    if (!openModal) resetInputs();
  }, [openModal]);

  return (
    <>
      <ButtonCore
        disabled={
          userPerfil?.type_user === "USER" &&
          !userPerfil?.permissions.permissions.includes(
            valuesPermissions.COMMISSIONS_PRODUCER.CREATE.id
          )
        }
        startIcon={<AddIcon />}
        title="Criar Comissão"
        onClick={() => setOpenModal(true)}
      />

      <ModalCore
        loadingSubmit={loadingSubmit}
        open={openModal}
        setOpen={setOpenModal}
        sxStyle={{ width: "800px" }}
        title="Comissão do Produtor"
        subTitle="Esta é a grade de comissões que o escritório paga."
        titleSubmit="Salvar"
        onChange={() => handleSubmit(false)}
        onClickNotClose={!id ? () => handleSubmit(true) : undefined}
      >
        <FormCommissionProducer />
      </ModalCore>
    </>
  );
};
